import { render, staticRenderFns } from "./UploadDocument.vue?vue&type=template&id=b925544c&scoped=true"
import script from "./UploadDocument.vue?vue&type=script&lang=ts"
export * from "./UploadDocument.vue?vue&type=script&lang=ts"
import style0 from "./UploadDocument.vue?vue&type=style&index=0&id=b925544c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b925544c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b925544c')) {
      api.createRecord('b925544c', component.options)
    } else {
      api.reload('b925544c', component.options)
    }
    module.hot.accept("./UploadDocument.vue?vue&type=template&id=b925544c&scoped=true", function () {
      api.rerender('b925544c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aws-files-modules/UploadDocument.vue"
export default component.exports